import { render, staticRenderFns } from "./otelyolcumnerede.vue?vue&type=template&id=3d32316d&scoped=true"
import script from "./otelyolcumnerede.vue?vue&type=script&lang=js"
export * from "./otelyolcumnerede.vue?vue&type=script&lang=js"
import style0 from "./otelyolcumnerede.vue?vue&type=style&index=0&id=3d32316d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d32316d",
  null
  
)

export default component.exports